import React from "react";

export function TakeoffPdfPage({ page, width, height, renderScale }) {
  const divRef = React.useRef(null);
  const renderTaskRef = React.useRef(null);
  React.useEffect(() => {
    if (!page || !divRef.current) return;
    if (renderTaskRef.current) { renderTaskRef.current.cancel(); renderTaskRef.current = null; }
    const DPR = window.devicePixelRatio || 1;
    const SCALE = Math.max(2, renderScale || 2) * DPR;
    const vp = page.getViewport({ scale: SCALE });
    const canvas = document.createElement('canvas');
    canvas.width = Math.ceil(vp.width);
    canvas.height = Math.ceil(vp.height);
    canvas.style.display = 'block';
    canvas.style.width = width + 'px';
    canvas.style.height = height + 'px';
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    const task = page.render({ canvasContext: ctx, viewport: vp });
    renderTaskRef.current = task;
    task.promise.then(() => {
      if (divRef.current) { divRef.current.innerHTML = ''; divRef.current.appendChild(canvas); }
    }).catch(() => {});
    return () => { if (renderTaskRef.current) { renderTaskRef.current.cancel(); renderTaskRef.current = null; } };
  }, [page, renderScale, width, height]);
  return (
    <div ref={divRef}
      style={{ display:'block', width: width+'px', height: height+'px', background:'#fff', flexShrink:0 }} />
  );
}
